/**
 * m:ss — the one way every clock in a circle session is written.
 *
 * Lived in TurnDisplay as a file-local helper until the top bar needed the
 * same number in the same shape. Two copies of a formatter is how "2:07" and
 * "2:7" end up on the same screen.
 */
export function mmss(totalSeconds: number): string {
  return `${Math.floor(totalSeconds / 60)}:${(totalSeconds % 60).toString().padStart(2, '0')}`;
}
